<template>
    <div 
        class="editable-field-properties editable-field-properties__container-wrapper"
        :class="{ 'static-mode__wrapper': mode === 'static' }"
        ref="propertiesWrapper"
    >
        <div class="editable-field-properties__header">
            <div class="d-flex align-center">
                <Edit2Icon class="mr-2" stroke-width="1.8" size="18"/>
                Edit
            </div>
            <v-btn
                @click="closeProperties"
                color="gray_400"
                text icon small
            >
                <XIcon stroke-width="2.2"/>
            </v-btn>
        </div>
        <div class="editable-field-properties__container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { XIcon, Edit2Icon } from 'vue-feather-icons'

export default {
    name: "EditableFieldPropertiesWindowTemplate",
    props: {
        mode: {
            type: String,
            default: "interactive"
        }
    },
    components: {
        XIcon, Edit2Icon
    },
    mounted() {
        this.adjustPosition();
        window.addEventListener('resize', this.adjustPosition);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.adjustPosition);
    },
    methods: {
        closeProperties() {
            this.$emit('close-properties');
        },
        adjustPosition() {
            const wrapper = this.$refs.propertiesWrapper;
            if (!wrapper) return;
            
            const INTERACTIVE_RIGHT_OFFSET = -350;
            // Si el modo es interactive, aplicar posicionamiento simple
            if (this.mode === 'interactive') {
                wrapper.style.position = 'absolute';
                wrapper.style.right = `${INTERACTIVE_RIGHT_OFFSET}px`;
                wrapper.style.bottom = '0';
                wrapper.style.left = 'auto';
                return;
            }

            // Para otros modos (como static), aplicar lógica responsive
            const windowWidth = window.innerWidth;
            const newRect = wrapper.getBoundingClientRect();
            const overflow = Math.trunc(Math.abs(windowWidth - newRect.right));
            const fixedWidth = 350;
            const dynamicWidth = Math.abs(fixedWidth - overflow) - 40;
            
            if (window.innerWidth > 1752) {
                wrapper.style.position = 'absolute';
                wrapper.style.right = 'auto';
                wrapper.style.left = 'auto';
            } else if (window.innerWidth < 1752) {
                wrapper.style.position = 'absolute';
                wrapper.style.left = 'auto';
                wrapper.style.right = `-${dynamicWidth}px`;
            }
        }
    }
}
</script>

<style scoped>
.editable-field-properties__container-wrapper {
    position: relative;
    /* Estilos existentes */
}

.static-mode__wrapper {
    position: sticky;
    right: 0;
    /* Ajuste para pantallas medianas */
    @media (max-width: 1024px) {
        right: 50px;
    }
    /* Ajuste para móviles */
    @media (max-width: 768px) {
        position: fixed;
        right: 20px;
        top: 20px;
        transform: none;
    }
}
</style>